
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[path]",
      function () {
        return require("private-next-pages/category/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[path]"])
      });
    }
  